import type { IRecord } from '@platform/core/types';
import { JOURNEY_KIND } from './journeyCodes';

/**
 * Лічильник пункту меню «Шляхи користувачів» (прототип v4 mdItems, jN): наскрізні шляхи, чий опис згадує англійську назву модуля
 * (MOD_BASE_NAME) без урахування регістру. Розділ показує інший перелік (journeyCodesOf) — так само, як прототип. Чиста функція.
 */
export function journeyCountOf(records: readonly IRecord[], enName: string): number {
  const name = enName.toLowerCase();
  if (!name) return 0;
  return records.filter((r) => r.values.kind === JOURNEY_KIND && String(r.values.description ?? '').toLowerCase().includes(name)).length;
}
